import { observer } from "mobx-react";
import t from "../../../stores/language";
import { useStyles } from "../configure-input";
import { TableView } from "../../../custom-components/table";
import { Button, Flex, Tooltip } from "@mantine/core";
import PopConfirm from "../../../custom-components/pop-confirm";
import { Icon } from "../../../custom-components/icons";
import { faDownload, faTrash } from "@fortawesome/pro-duotone-svg-icons";
import { useQuery, useStore } from "../../../stores/store";
import { QueryKeys } from "../../../models/models";

const ReportArchivesView = observer(function ReportsView() {
  const { classes } = useStyles();
  const { store } = useStore();
  const { data: reportArchives, isLoading: loading } = useQuery({
    queryKey: [QueryKeys.ReportArchives],
    queryFn: async () => {
      return await store.GetAllReportsArchives();
    },
  });
  const { data: reports, isLoading: reportLoading } = useQuery({
    queryKey: [QueryKeys.Reports],
    queryFn: async () => {
      return await store.GetAllReports();
    },
  });
  const deleteReport = (id: number) => {
    store.DeleteReportArchive(id);
  };
  const downloadReport = (id: string) => {
    store.downloadReportArchive(id);
  };
  const GetReportsInvolved = (ids: number[]) => {
    if (ids.length === 0) {
      return "";
    }
    const reportNames: string[] = [];
    ids.forEach((id) => {
      const report = reports?.find((d) => d.id === id);
      if (report != null) {
        reportNames.push(report.name);
      }
    });
    if (reportNames.length > 4) {
      return reportNames.slice(0, 3).join(",");
    }
    return reportNames.join(",");
  };
  const GetActions = (row: { [key: string]: string | null | number }) => {
    return (
      <Flex justify={"center"} gap={5}>
        <Tooltip label={t("Delete")} withArrow withinPortal>
          <Button onClick={() => downloadReport(row.id?.toString() ?? "")} size="xs" variant="subtle" compact className={classes.iconButton}>
            <Icon icon={faDownload} size="xl" />
          </Button>
        </Tooltip>
        <PopConfirm confirmText={t("Are You Sure?")} width={180} onConfirm={() => deleteReport(row.id as number)}>
          <Tooltip label={t("Delete")} withArrow withinPortal>
            <Button size="xs" variant="subtle" compact className={classes.iconButton}>
              <Icon icon={faTrash} size="xl" color={"red"} />
            </Button>
          </Tooltip>
        </PopConfirm>
      </Flex>
    );
  };
  const convertUtcToLocal = (dateString: string) => {
    const date = new Date(dateString);
    return date.toLocaleDateString();
  };
  return loading || reportLoading ? (
    <></>
  ) : (
    <>
      <div className={classes.reportsContainer}>
        <div className={classes.title}>
          <span>{t("Report Archives")} </span>
        </div>
        <TableView
          data={
            reportArchives?.map((r) => {
              return {
                name: r.name,
                reports: GetReportsInvolved(r.config?.reportIds ?? []),
                createdOn: convertUtcToLocal(r.createdOn),
                id: r.id,
              };
            }) ?? []
          }
          columns={[
            { key: "name", label: "Name", width: 580 },
            { key: "reports", label: "Report Name", width: 580 },
            { key: "createdOn", label: "Downloaded On", width: 580 },
          ]}
          height={"calc(100vh - 206px)"}
          actions={GetActions}
          headerAlign={{ Actions: "center" }}
        />
      </div>
    </>
  );
});

export default ReportArchivesView;
